import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { SectionGalleryImageBody } from "types/api/blocks/sectionGalleryImage";

function useSectionGalleryImageApi() {
    const { del, post, put } = useHttpManaged();
    const createSectionGalleryImage = React.useCallback((body: SectionGalleryImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, SectionGalleryImageBody, ResponseWithId>({
            url: "/blocks/section-gallery-image",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateSectionGalleryImage = React.useCallback((pathParams: PathParamsWithId, body: SectionGalleryImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, SectionGalleryImageBody, null>({
            url: "/blocks/section-gallery-image/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteSectionGalleryImage = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-gallery-image/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        createSectionGalleryImage,
        updateSectionGalleryImage,
        deleteSectionGalleryImage
    };
}

export default useSectionGalleryImageApi;